<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display:flex;justify-content:flex-start;align-items:center;">
        <button-add @click="toAddPage" v-if="permissionCodes.indexOf('') !== -1"></button-add>
      </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :operationArr="operationArr" @deleteLine="deleteLine" :pageNum="requestData.pageNum" :pageSize="requestData.pageSize" @changePagination="changePagination" :total="total" @goToModifyPage="goToModifyPage"/>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Lock";
import { bus } from "../../../utils/bus";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonAdd from "../../../components/common/buttons/button-add";
import { nAlert, nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonAdd,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    Breadcrumb
  },
  name: "lock-gate-manage",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧门锁",
          name: "lock-concentrator-manage"
        },
        {
          value: "门锁管理"
        }
      ],
      fixTypeList: [],
      tableHead: [
        {
          prop: "roomNumber",
          label: "房间号"
        },
        {
          prop: "deviceCode",
          label: "设备编号"
        },
        {
          prop: "deviceModel",
          label: "设备型号"
        },
        {
          prop: "deviceFactroy",
          label: "设备厂商"
        },
        {
          prop: "electricity",
          label: "电量"
        },
        {
          prop: "concentratorCode",
          label: "关联集中器"
        },
        {
          prop: "identifyMethod",
          label: "识别方式"
        }
      ],
      tableData: [],
      operationArr: ["modify", "delete"],
      requestData: {
        searchKey: "",
        pageSize: 10,
        pageNum: 1
      },
      uploadUrl: "",
      total: 0,
      selectionArr: []
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    getPage() {
      this.$axios
        .post(api.getLockPage, this.requestData)
        .then(res => {
          this.total = res.data.data.total;
          let list = res.data.data.list;
          list.map(v=>{
            v.code=v.deviceCode
          })
          this.tableData = list;
        })
        .catch(errorHandler("获取分页失败"));
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteLockByCodes, code)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.selectionArr = [];
            this.getPage();
          }
        })
        .catch(errorHandler("删除失败"));
    },
    toAddPage() {
      this.$router.push({
        name: "lock-gate-add"
      });
    },
    goToModifyPage(code) {
      this.$router.push({
        path: `lock_gate_modify/${code}`
      });
    },
    searchKey(v) {
      this.requestData.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    changePagination(data) {
      this.requestData.pageNum = data[0];
      this.requestData.pageSize = data[1];
      this.getPage();
    },
  }
};
</script>


<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/GateLock/GateLockManage/LockGateManage.vue